/** Check this link before editing https://material.angular.io/components/dialog/api */

// Angular
import { Component, Inject, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { ISegment, ISegments } from "libraries/service/resources/airTrip/IGetAirTripQuotes";
import { ILabels } from "libraries/interfaces/ILabels";
import { Yii } from "libraries/interfaces/Yii";
import { ISegmentSelect, ISegmentSelectEmission } from "../segment-list/all-segment-list.component";

export interface IAllSegmentsDialogData {
    quoteId: string;
    segmentList: ISegments;
    selectedSegment: string[];
}

@Component({
    selector: 'all-segment-dialog',
    template: `
        <card [@.disabled]="true" mat-dialog-content>
            <header class="card-header-content">
                <h1>{{ wording.title }}</h1>
                <div class="btn-container">
                    <btn type="actionLink"
                         [label]="wording.close"
                         (onClick)="close()"></btn>
                    <btn type="actionDo"
                         [label]="wording.submit"
                         (onClick)="submit()"></btn>
                </div>
            </header>
            <div class="card-body-content">
                <all-segment-list *ngIf="tempSelection"
                                  [segmentList]="data.segmentList | values"
                                  [selectedSegment]="tempSelection"
                                  (onSelect)="select($event)"></all-segment-list>
            </div>
        </card>
    `,
    styles: [`
        .card-body-content {
            padding: 15px 15px 0 15px;
        }
    `]
})
export class AllSegmentDialogComponent implements OnInit {

    public wording: ILabels = {
        title: Yii.t('wui-iqba-js', 'Tous les vols'),
        close: Yii.t('wui-iqba-js', 'Annuler'),
        submit: Yii.t('wui-iqba-js', 'Valider'),
    };

    public tempSelection: string[];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: IAllSegmentsDialogData,
        private dialogRef: MatDialogRef<AllSegmentDialogComponent, ISegmentSelect>
    ) {
    }

    public ngOnInit(): void {
        //some times selectedSegment are not sort the same way than segmentList
        this.tempSelection = Object.values(this.data.segmentList)
            .map((segment: ISegment) => this.data.selectedSegment.find((selectedKey: string) => segment.journey.includes(selectedKey)));
    }

    public close(): void {
        this.dialogRef.close();
    }

    public values(segments: ISegments): ISegment[] {
        return Object.values(segments);
    }

    public select(newSelection: ISegmentSelectEmission): void {
        this.tempSelection[newSelection.index] = newSelection.journeyId;
    }

    public submit(): void {
        this.dialogRef.close({selectedSegment: this.tempSelection, quoteId: this.data.quoteId});
    }
}
